<template>
    <div id="team">
        <AppBreadCrumb :paths="[{ title: 'Team' }]" :select="true" />
        <div class="route-page-content breadcrumb-content">
            <UsersMenu v-model="selectedTab" />
            <div class="page-content-wrapper">
                <Users v-if="selectedTab === 'users'" />
                <Roles v-if="selectedTab === 'roles'" />
                <Subjects v-if="selectedTab === 'departments'" />
                <BannedVisitors v-if="selectedTab === 'banned-visitors'" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import UsersMenu from "./components/UsersMenu.vue";
import Users from "./pages/Users.vue";
import Roles from "./pages/Roles.vue";
import BannedVisitors from "./pages/BannedVisitors.vue";
import Subjects from "./pages/Subjects.vue";
import ChatbotMenu from "../Chatbot/ChatbotMenu.vue";
import UsersMenuItems from "./components/UsersMenuItems";

const log = log2("Team");
export default {
    name: "Team",
    components: {
        ChatbotMenu,
        Subjects,
        Roles,
        AppBreadCrumb,
        UsersMenu,
        Users,
        BannedVisitors,
    },
    data() {
        return {
            selectedTab: this.$route.path.replace(/(\/|team)/g, "") || "users",
            searchText: this.$route.query.searchText || undefined,
        };
    },
    computed: {
        ...mapState({
            subjects: (state) => state.subject.subjects.data,
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        init() {
            this.selectedTab = this.$route.path.replace(/(\/|team)/g, "") || "users";
            const selected = UsersMenuItems(this).find((x) => x.key === this.selectedTab);
            if (!selected?.enabled) {
                const available = UsersMenuItems(this).find((x) => x.enabled);
                if (available) {
                    this.selectedTab = available.key;
                } else {
                    this.$router.push("/denied");
                }
            }
        },
    },
    created() {
        this.init();
    },
    watch: {
        selectedTab(newVal) {
            this.$router.push(`/team/${newVal}`);
        },
        "$route.path": {
            deep: true,
            handler() {
                this.init();
            },
        },
    },
};
</script>
<style style="scss" scoped>
#team {
    .page-content-wrapper {
        padding: 10px;
    }
}
</style>
